import { configureStore } from '@reduxjs/toolkit';
import {
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
  TypedUseSelectorHook,
} from 'react-redux';
import CustomizerReducer from './customizer/CustomizerSlice';
import AuthReducer from './apps/auth/AuthSlice';
import FlowReducer from './apps/flow/FlowSlice';

const store = configureStore({
  reducer: {
    auth: AuthReducer,
    customizer: CustomizerReducer,
    flowReducer: FlowReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useDispatch = () => useAppDispatch<AppDispatch>();

export const useSelector: TypedUseSelectorHook<AppState> = useAppSelector;

export function getStore() {
  return store;
}

export default store;
